// @ts-nocheck
/* Port of v1 components/partials/components/PseudoCdrBadge.js */
import React from 'react';
import { isPseudoCdrRow } from '@/utilities/pseudoCdr';

function PseudoCdrBadge({ row }) {
  const isPseudo = isPseudoCdrRow(row);

  return (
    <span
      title={
        isPseudo
          ? 'Pseudo CDR — synthesised by the switch, not a real billable call leg'
          : 'Real CDR'
      }
      className={
        'inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold ring-1 ring-inset ' +
        (isPseudo
          ? 'bg-orange-100 text-orange-700 ring-orange-200 dark:bg-orange-950/40 dark:text-orange-300 dark:ring-orange-900'
          : 'bg-slate-100 text-slate-600 ring-slate-200 dark:bg-slate-800/60 dark:text-slate-300 dark:ring-slate-700')
      }
    >
      {isPseudo ? 'Yes' : 'No'}
    </span>
  );
}

export default React.memo(PseudoCdrBadge);
